import { View } from "./ClientCommunication.view";

export const Container = () => {
  return <View />;
};
